import { collection, getDocs } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase/firebase";
import { useDistributorAuth } from "../../context/DistributorAuthContext";
import { Link } from "react-router-dom";
import "./AllRetailer.css";
import { getUserInventorySummary } from "../../hooks/userInventoryData";
import { TablePagination } from "@mui/material";

function SuperStockist() {
  const [inventory, setRetailer] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { setDistributor } = useDistributorAuth(); 
  const navigate = useNavigate();
  const [inventorySummaries, setInventorySummaries] = useState({});


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

   // Handle page change
   const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const inventoryCollection = collection(db, "users");
        const inventorySnapshot = await getDocs(inventoryCollection);
        const inventoryList = inventorySnapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((ret) => ret.role?.toLowerCase().trim() === "super stockist");
      
        setRetailer(inventoryList);
        setFilteredInventory(inventoryList);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchInventory();
  }, []);
  

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
  
    const filtered = inventory.filter((retailer) => {
      return Object.values(retailer).some((field) => {
        if (field !== null && field !== undefined) {
          return field.toString().toLowerCase().includes(value);
        }
        return false;
      });
    });
  
    setFilteredInventory(filtered);
  };
  

  const clearSearch = () => {
    setSearchTerm("");
    setFilteredInventory(inventory);
  };

  const handleLogin = (distributor) => {
    setDistributor(distributor); // Set distributor in the context
    localStorage.setItem("distributor", JSON.stringify(distributor)); // Save to localStorage
    navigate("/distributor/stats", { replace: true }); // Redirect to distributor stats page
  };


  const fetchSummary = async (uid) => {
    let totalInventory = 0;
    let distinctBrandsCount = 0;
  
    try {
      const result = await getUserInventorySummary(uid);
      totalInventory = result.totalInventory;
      distinctBrandsCount = result.distinctBrands.length;
  
      console.log(`Total Inventory: ${totalInventory}`);
      console.log(`Distinct Brands Count: ${distinctBrandsCount}`);
    } catch (error) {
      console.error("Failed to fetch inventory summary:", error.message);
    }
  
    return { totalInventory, distinctBrandsCount };
  };
  
  useEffect(() => {
    const fetchAllSummaries = async () => {
      const summaries = {};
      await Promise.all(
        filteredInventory.map(async (retailer) => {
          const { totalInventory, distinctBrandsCount } = await fetchSummary(retailer.uid);
          summaries[retailer.uid] = { totalInventory, distinctBrandsCount };
        })
      );
      setInventorySummaries(summaries);
    };
  
    if (filteredInventory.length > 0) {
      fetchAllSummaries();
    }
  }, [filteredInventory]);
  


  return (
    <div className="admin-layout">
         <h1 className="font-extrabold text-4xl mb-3 text-center">Super Stockist</h1>
      <div className="search-bar">
      <input
  type="text"
  placeholder="Search by Name, ID, Username, Email, Mobile, etc."
  value={searchTerm}
  onChange={handleSearch}
  className="search-input"
/>

        <div className="btns">
          <button onClick={handleSearch} className="search-button">
            Search
          </button>
          <button onClick={clearSearch} className="clear-button">
            Clear
          </button>
        </div>
      </div>

      {loading && <div>Loading...</div>}
      {error && <div>Error: {error}</div>}

      <table className="admin-table">
        <thead>
          <tr>
            <th>Name</th>
            {/* <th>ID</th> */}
            <th>Username</th>
            <th>Password</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Total Inventory</th>
            <th>Total Brands</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredInventory.map((retailer, index) => (
            <tr key={index}>
              <td>
                <Link to={`/new-user-details/${retailer.uid}`} className="text-blue-700">
                {retailer.name}
                </Link>
              </td>
              {/* <td className="text-xs">{retailer.uid}</td> */}
              <td >{retailer.userName}</td>
              <td>{retailer.password}</td>
              <td className="text-sm">{retailer.email}</td>
              <td>{retailer.mobile}</td>
              <td>{inventorySummaries[retailer.uid]?.totalInventory ?? 'Loading...'}</td>
            <td>{inventorySummaries[retailer.uid]?.distinctBrandsCount ?? 'Loading...'}</td>
              <td>
                <button
                  onClick={() => handleLogin(retailer)}
                  className="login-button"
                >
                  Login
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>


 {/* MUI Table Pagination */}
 <div className="bg-slate-200 mt-5">

<TablePagination
  component="div"
  count={filteredInventory.length}
  page={page}
  onPageChange={handleChangePage}
  rowsPerPage={rowsPerPage}
  onRowsPerPageChange={handleChangeRowsPerPage}
  rowsPerPageOptions={[5, 10, 25]}
/>
</div>

      <div style={{ height: "100px" }}></div>
    </div>
  );
}

export default SuperStockist;
